import { Button } from "$components/button/button";
import PaymentStatusChip from "$routes/_lib/payment-status-chip";
import { InsuranceValidityChip } from "$routes/patient/[:patientId]/_lib/patient-info-dropdown/insurance-status";
import { styled, Typography } from "@material-ui/core";
import { PaymentStatus } from "elephant-web/gql";
import { useIntl } from "react-intl";
import type { PatientCentrePatient } from ".";

const Statuses = styled("div")({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "flex-start",
  width: "100%",
  rowGap: "4px",
  columnGap: "16px",
});

const StatusRowSection = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
});

const StatusRowLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700],
  fontSize: "14px",
  marginRight: "8px",
}));

const InsuranceProvider = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  fontSize: "14px",
  marginRight: "8px",
}));

const MamaPurseBalance = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  fontSize: "14px",
  marginLeft: "8px",
}));

export const StatusRow: React.FC<{
  patient: PatientCentrePatient;
  isPatientPayEnabled: boolean;
  onClickLogRenewalPayment?: () => void;
}> = ({ patient, isPatientPayEnabled, onClickLogRenewalPayment }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Statuses>
        <StatusRowSection>
          <StatusRowLabel>
            {formatMessage({
              id: "patient.status.insurance",
              defaultMessage: "Insurance:",
            })}
          </StatusRowLabel>
          <InsuranceProvider>
            {patient.insurance?.insuranceProvider?.name || "None"}
          </InsuranceProvider>
          {patient.insurance && (
            <InsuranceValidityChip
              insurance={patient.insurance}
              currentVisitInsurances={patient.currentVisit?.insuranceList}
            />
          )}
        </StatusRowSection>
        {isPatientPayEnabled && (
          <StatusRowSection>
            <StatusRowLabel>
              {formatMessage({
                id: "patient.status.registrationFee",
                defaultMessage: "Registration fee:",
              })}
            </StatusRowLabel>
            <PaymentStatusChip
              status={
                patient.registrationPayment?.status ?? PaymentStatus.Unpaid
              }
            />
          </StatusRowSection>
        )}
      </Statuses>
      {isPatientPayEnabled &&
        onClickLogRenewalPayment &&
        [PaymentStatus.Unpaid, PaymentStatus.Expired].includes(
          patient.registrationPayment?.status,
        ) && (
          <Button
            variant="contained"
            color="secondary"
            onClick={onClickLogRenewalPayment}
          >
            {formatMessage({
              id: "patient.status.logRenewalPayment",
              defaultMessage: "Log renewal payment",
            })}
          </Button>
        )}
    </>
  );
};
